const CustomToaster = ({ isTop, isRight, points, text }) => {
    return (
        <div className="relative  ">
            {isRight && (
                <div className="absolute top-[50%] translate-y-[-50%] -right-2 w-0 h-0 border-t-[10px] border-b-[10px] border-l-[9px] border-t-transparent border-b-transparent border-l-[#BCD3CE]"></div>
            )}
            {isTop && (
                <div className="absolute -top-2 left-12 w-0 h-0 border-l-[10px] border-r-[10px] border-b-[9px] border-l-transparent border-r-transparent border-b-[#BCD3CE]"></div>
            )}

            <div
                className={`bg-[#BCD3CE] rounded-[.25rem] py-[.65rem] px-3 text-[#3C665D] font-semibold flex ${
                    isRight ? 'flex-row-reverse' : ''
                } items-center gap-3  `}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path
                        d="M10.082 6.41732H11.9154V8.25065H10.082V6.41732ZM10.082 10.084H11.9154V15.584H10.082V10.084ZM10.9987 1.83398C5.9387 1.83398 1.83203 5.94065 1.83203 11.0007C1.83203 16.0607 5.9387 20.1673 10.9987 20.1673C16.0587 20.1673 20.1654 16.0607 20.1654 11.0007C20.1654 5.94065 16.0587 1.83398 10.9987 1.83398ZM10.9987 18.334C6.9562 18.334 3.66536 15.0431 3.66536 11.0007C3.66536 6.95815 6.9562 3.66732 10.9987 3.66732C15.0412 3.66732 18.332 6.95815 18.332 11.0007C18.332 15.0431 15.0412 18.334 10.9987 18.334Z"
                        fill="#879E99"
                    />
                </svg>
                <p className="text-xs">
                    {points !== 0 && (
                        <span>
                            You have collected {points} extra Impact points! <br />
                        </span>
                    )}
                    <span>{text}</span>
                </p>
            </div>
        </div>
    );
};

export default CustomToaster;
